module.exports = __webpack_public_path__ + "static/media/idaho.8ab03569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/backgrounds/idaho.jpg
// module id = 539
// module chunks = 0